import { getCoreUtils } from "./kCoreHandler";

/**
 * kCallbackNotify - the guarded fire-and-forget call of an optional change-notification callback.
 * Only for notifications nobody waits on: a callback that answers a caller (Done/Reply) must not be
 * skipped by the error gate, so it does not belong here.
 */
export class kCallbackNotify {
    /**
     * Calls Callback(Arg) unless it is null/undefined or the error gate is up; a throw is reported under Label.
     * DOCUMENTED EXCEPTION: the handler label is the CALLER's (Label), not "kCallbackNotify.Call", so the
     * report names the member that notified.
     */
    public static Call = <T>(Callback: ((Arg: T) => void) | null | undefined, Arg: T, Label: string): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try {
            if (Callback !== null && Callback !== undefined) { Callback(Arg); }
        } catch (e) {
            getCoreUtils().KGlobalErrorHandler(e, Label);
        }
    };
}
